import React, { useState } from 'react';
import './MakeAnEnquiry.css';
import { submitEnquiry } from '../services/inquiryService';

const MakeAnEnquiry = () => {
  const [formData, setFormData] = useState({
    name: '',
    contact: '',
    dates: '',
    venue: '',
    service: '',
    bridalOptions: [],
    otherService: '',
    time: '',
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === 'select-multiple') {
      const options = Array.from(e.target.selectedOptions, (option) => option.value);
      setFormData({ ...formData, [name]: options });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitEnquiry({
        name: formData.name,
        contact: formData.contact,
        event_dates: formData.dates,
        venue: formData.venue,
        service: formData.service,
        bridal_suboptions: formData.bridalOptions.join(', '),
        other_service: formData.otherService,
        desired_time: formData.time,
      });
      alert('Thank you for reaching out! Our team will be in touch soon.');
      setFormData({ name: '', contact: '', dates: '', venue: '', service: '', bridalOptions: [], otherService: '', time: '' });
    } catch (error) {
      alert('Error submitting form. Please try again later.');
      console.error(error);
    }
  };


  return (
    <div className="enquiry-page">
      <div className="top-heading-section">
        <h1>Make an Enquiry</h1>
      </div>

      <p className="enquiry-subtext">
        One click, and your makeup dreams are on their way — drop us a message, we’d love to glam with you!
      </p>

      <form className="enquiry-form" onSubmit={handleSubmit}>
        <label>Name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required />

        <label>Contact Number</label>
        <input type="tel" name="contact" value={formData.contact} onChange={handleChange} placeholder="Enter your phone number" required />

        <label>Select Event Date</label>
        <input type="date" name="dates" value={formData.dates} onChange={handleChange} required />

        <label>Venue of the Event</label>
        <input type="text" name="venue" value={formData.venue} onChange={handleChange} placeholder="Venue location" required />

        <label>Service Looking For</label>
        <select name="service" value={formData.service} onChange={handleChange} required>
          <option value="">Select a service</option>
          <option value="Bridal Makeup">Bridal Makeup</option>
          
          <option value="Party Makeup">Party Makeup</option>
          <option value="Groom Makeup">Groom Makeup</option>
          <option value="Bridal Trial">Bridal Trial</option>
          <option value="Editorial Makeup">Editorial Makeup</option>
          <option value="Other">Other</option>
        </select>

        {formData.service === 'Bridal Makeup' && (
          <>
            <label>Bridal Sub-options (Multiple)</label>
            <select name="bridalOptions" multiple onChange={handleChange} value={formData.bridalOptions}>
              <option value="Roka">Roka</option>
              <option value="Haldi">Haldi</option>
              <option value="Welcome Dinner">Welcome Dinner</option>
              <option value="Lunch">Lunch</option>
              <option value="Mehendi">Mehendi</option>
              <option value="Engagement">Engagement</option>
              <option value="Sangeet">Sangeet</option>
              <option value="Cocktail">Cocktail</option>
              <option value="Reception">Reception</option>
              <option value="Wedding">Wedding</option>
            </select>
          </>
        )}

        {formData.service === 'Other' && (
          <>
            <label>Other (Please Specify)</label>
            <input type="text" name="otherService" value={formData.otherService} onChange={handleChange} placeholder="Type your service" />
          </>
        )}

        <label>Desired Time to be Ready At</label>
        <input type="time" name="time" value={formData.time} onChange={handleChange} required />

        <button type="submit" className="submit-btn">Submit</button>
      </form>
    </div>
  );
};

export default MakeAnEnquiry;
